<aux-map-activities-modal-total-row [invoice]="invoice" [totals]="totals()" />

<div class="my-4 flex justify-end">
  <aux-button
    variant="secondary"
    icon="Plus"
    label="Add New Activity"
    classList="!border-none h-[35px]"
    (clickEmit)="addNewRow()"
  />
</div>

@if (this.loading) {
  <div class="flex h-[265px] w-full">
    <div class="spinner m-auto h-32 w-32 border-8"></div>
  </div>
} @else {
  <ag-grid-angular
    class="ag-theme-aux unselectable h-[285px] w-full tabular-nums"
    [rowData]="gridData"
    [gridOptions]="gridOptions"
    [columnDefs]="columnDefs"
    (gridReady)="onGridReady($event)"
  />
}

<div class="mt-[30px] w-[500px]">
  <div class="flex items-center justify-between space-x-1">
    <span class="mr-1">Comments</span>

    <span class="text-aux-gray-dark-2">{{ this.noteControl.value?.length || 0 }} / 1000</span>
  </div>

  <aux-input
    placeholder="Enter comments here..."
    [textArea]="true"
    [rows]="5"
    resize="none"
    class="textarea-input mt-1"
    [maxlength]="1000"
    [formControl]="noteControl"
  />
</div>

@if (ref.data?.lastUpdated) {
  <div class="mt-2">Last Updated: {{ ref.data?.lastUpdated }}</div>
}
